// Znaczniki **pogrubienia** w tekście szablonu (np. wzór „Pogrubione dane”).

/**
 * Parsuje znaczniki **bold** w tekście.
 * Zwraca czysty tekst (bez **) oraz obiekt styles dla Fabric.js Textbox.
 */
export function parseBoldMarkers(text) {
    const lines = text.split('\n');
    const cleanLines = [];
    const styles = {};

    lines.forEach((line, lineIndex) => {
        let cleanLine = '';
        let charOffset = 0;
        let remaining = line;

        while (remaining.length > 0) {
            const boldStart = remaining.indexOf('**');
            if (boldStart === -1) {
                cleanLine += remaining;
                break;
            }

            cleanLine += remaining.slice(0, boldStart);
            charOffset += boldStart;
            remaining = remaining.slice(boldStart + 2);

            const boldEnd = remaining.indexOf('**');
            if (boldEnd === -1) {
                cleanLine += remaining;
                break;
            }

            const boldText = remaining.slice(0, boldEnd);
            if (!styles[lineIndex]) styles[lineIndex] = {};
            for (let i = 0; i < boldText.length; i++) {
                styles[lineIndex][charOffset + i] = { fontWeight: 'bold' };
            }
            cleanLine += boldText;
            charOffset += boldText.length;
            remaining = remaining.slice(boldEnd + 2);
        }

        cleanLines.push(cleanLine);
    });

    const hasBold = Object.keys(styles).length > 0;
    return { cleanText: cleanLines.join('\n'), styles, hasBold };
}
